/**
 * Search functionality for locations
 */
export class Search {
  constructor(inputSelector, resultsSelector, locations) {
    this.input = document.querySelector(inputSelector);
    this.resultsContainer = document.querySelector(resultsSelector);
    this.locations = locations;
    this.listeners = {};

    this.setupEventListeners();
  }

  setupEventListeners() {
    let debounceTimer;

    this.input.addEventListener('input', (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        this.performSearch(e.target.value);
      }, 300);
    });

    // Close results when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.input.contains(e.target) && !this.resultsContainer.contains(e.target)) {
        this.hideResults();
      }
    });
  }

  performSearch(query) {
    if (query.length < 2) {
      this.hideResults();
      return;
    }

    const lowerQuery = query.toLowerCase();
    const results = [];

    for (const [id, location] of Object.entries(this.locations)) {
      if (location.name.toLowerCase().includes(lowerQuery) ||
          location.display_name.toLowerCase().includes(lowerQuery)) {
        results.push({ id, ...location });
      }
    }

    this.displayResults(results.slice(0, 10)); // Limit to 10 results
  }

  displayResults(results) {
    if (results.length === 0) {
      this.hideResults();
      return;
    }

    this.resultsContainer.innerHTML = results.map(result => `
      <div class="search-result-item" data-location-id="${result.id}">
        <strong>${result.name}</strong>
        <br>
        <small>${result.display_name}</small>
      </div>
    `).join('');

    // Add click handlers
    this.resultsContainer.querySelectorAll('.search-result-item').forEach(item => {
      item.addEventListener('click', () => {
        const locationId = item.dataset.locationId;
        const location = { id: locationId, ...this.locations[locationId] };
        this.emit('select', location);
        this.hideResults();
        this.input.value = location.name;
      });
    });

    this.resultsContainer.classList.add('active');
  }

  hideResults() {
    this.resultsContainer.classList.remove('active');
    this.resultsContainer.innerHTML = '';
  }

  on(event, callback) {
    this.listeners[event] = callback;
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event](data);
    }
  }
}
